// extracted by mini-css-extract-plugin
module.exports = {"modal":"DevelopersModal_modal__NIIYb","home-link":"DevelopersModal_home-link__MhO8T","link":"DevelopersModal_link__t3Wgn"};